import {TheNews} from './the-news';
import {AnnouncementContent, AnnouncementDetailContent} from './announcement-content';
import {UserInfo} from './user-info';
import {ChangePasswordForm} from './change-password-form';
import {ComplaintContent} from './complaint-content';
import {ComplaintForm} from './complaint-form';
import {ComplaintDetailContent} from './complaint-detail-content';
import {FavoriteProductContent} from './favorite-product-content';
import {FormPostDemand} from './post-demand';
import {MyRequestContent} from './my-request-content';
import {ShoppingCart} from './shopping-cart';
import {OrderHistoryContent, OrderHistoryDetailContent} from './order-history-content';

export {
  TheNews,
  AnnouncementContent,
  AnnouncementDetailContent,
  UserInfo,
  ChangePasswordForm,
  ComplaintContent,
  ComplaintForm,
  ComplaintDetailContent,
  FavoriteProductContent,
  MyDemandContent,
  FormPostDemand,
  MyRequestContent,
  ShoppingCart,
  MyDemandDetailContent,
  OrderHistoryContent,
  OrderHistoryDetailContent
};



// WEBPACK FOOTER //
// ./components/users/sub-view/index.js